import React from 'react';
import Icon from '../icons/Icon';
import { IIconButton } from '../../../interfaces/buttons/buttons';


const IconButton = ({ ariaLabel, className, isDisabled = false, onButtonClick, iconName, parentRef}: IIconButton) => {
    return (
        <button
            className={`icon-button ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
            ref={parentRef}
        >
            <Icon iconName={iconName} sizeInPx='12' color='var(--thriveCharcoal)'/>
        </button>
    );
};

export default IconButton